import PropTypes from "prop-types";
import React from "react";

import TrimmaContext from "../contexts/TrimmaContext";

TrimmaProvider.propTypes = {
  children: PropTypes.node,
  apiPath: PropTypes.string.isRequired,
};

export default function TrimmaProvider({ children, apiPath }) {
  return (
    <TrimmaContext.Provider
      value={{
        apiPath,
      }}
    >
      {children}
    </TrimmaContext.Provider>
  );
}
